import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const StartFooter = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const linkSx = {
    fontSize: "12.5px",
    color: "var(--muted)",
    cursor: "pointer",
    transition: "color .15s",
    "&:hover": { color: "var(--ink)" },
  };

  return (
    <Box
      component="footer"
      sx={{
        borderTop: "1px solid var(--line)",
        bgcolor: "#fff",
      }}
    >
      <Box
        sx={{
          maxWidth: 1280,
          mx: "auto",
          px: { xs: 3, md: 5 },
          py: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
        }}
      >
        <Typography sx={{ fontSize: "12.5px", color: "var(--muted)" }}>
          © {new Date().getFullYear()} Jesteś w domu · Agregator ofert nieruchomości
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", columnGap: 2.5, rowGap: 1 }}>
          <Typography
            component="span"
            onClick={() => navigate("/contact")}
            sx={linkSx}
          >
            {t("contact", { ns: "words", defaultValue: "Kontakt" })}
          </Typography>
          <Typography
            component="span"
            onClick={() => navigate("/terms")}
            sx={linkSx}
          >
            {t("termsOfService", { ns: "home", defaultValue: "Regulamin" })}
          </Typography>
          <Typography
            component="span"
            onClick={() => navigate("/privacy")}
            sx={linkSx}
          >
            {t("privacyPolicy", { ns: "home", defaultValue: "Polityka prywatności" })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StartFooter;
